import React from "react";
import logger from "logger";
import Tooltip from "@material-ui/core/Tooltip";

export const DialogButton = (props) => {
  const { label, tooltip, onClick, disabled } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ padding: "10px", marginTop: "10px" }}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

//import { DialogButton } from "Common/DialogButton";
